<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>Add Plan</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="primary" @click="$router.go(-1)">
              <v-icon left> mdi-chevron-double-left </v-icon>
              {{ `${this.$t("bills.add.buttons.back")}` }}
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-10">
            <v-form>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="plan.title"
                    name="title"
                    label="Title"
                    v-validate="'required'"
                    :error="
                      errors.first('title') != null ||
                      serverSideErrors.title != null
                    "
                    :error-messages="
                      errors.first('title') || serverSideErrors.title
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-textarea
                    v-model="plan.description"
                    name="description"
                    label="Description"
                  
                    rows="2"
                    :error="
                      errors.first('description') != null ||
                      serverSideErrors.description != null
                    "
                    :error-messages="
                      errors.first('description') ||
                      serverSideErrors.description
                    "
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="plan.amount"
                    name="amount"
                    label="Amount"
                    type="number"
                    v-validate="
                      'required|numeric|max_value:9999999|min_value:1'
                    "
                    :error="
                      errors.first('amount') != null ||
                      serverSideErrors.amount != null
                    "
                    :error-messages="
                      errors.first('amount') || serverSideErrors.amount
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="plan.number_of_days"
                    name="Number of days"
                    label="Number of days"
                    type="number"
                    v-validate="
                      'required|numeric|max_value:9999999|min_value:1'
                    "
                    :error="
                      errors.first('Number of days') != null ||
                      serverSideErrors.number_of_days != null
                    "
                    :error-messages="
                      errors.first('Number of days') ||
                      serverSideErrors.number_of_days
                    "
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-btn
              color="secondary"
              dark
              class="px-8 ml-2"
              @click="savePlan"
              :loading="loading"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      loading: false,
      serverSideErrors: {},
      plan: {
        title: "",
        description: "",
        amount: "",
        number_of_days: "",
      },
    };
  },

  methods: {
    ...mapMutations("alert", ["setAlert"]),

    savePlan() {
      let _self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;
          _self.$axios.post("/superadmin/plan", _self.plan)
          
          .then((response) => {
              let data = response.data;

              _self.loading = false;
              _self.serverSideErrors = {};

              if (data.status) {
                this.setAlert({
                  showAlert: true,
                  message: data.message,
                  variant: "green accent-4",
                  timeout: 2000,
                });
                _self.$router.push({ path: "/superadmin/plan" });
              } else {
                if (!data.errors) {
                  this.setAlert({
                    showAlert: true,
                    message: data.message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                } else {
                  for (let i = 0; i < data.errors.length; i++) {
                    this.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                }
              }
            });
        
        }
      });
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
};
</script>

<style scoped>
.font-30 {
  font-size: 30px !important;
}
/* make the icon clickable in badge slot */
.edit-icon {
  z-index: 1000;
}
</style>
